// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  padding-top: 22px;
  background: var(--Colors-UI-Neutral-Grey-100, #F5F5F5);
  padding-bottom: var(--Spacings-Spacing-04, 24px);
  padding-left: var(--Spacings-Spacing-04, 16px);
  padding-right: var(--Spacings-Spacing-04, 16px);
  flex-direction: column;
  /*align-items: flex-start;*/
  gap: var(--Spacings-Spacing-03, 12px);
  align-self: stretch;
  border-radius: var(--Radius-radius-l, 16px);
  /*box-shadow: 0px 2px 8px 0px rgba(0, 93, 152, 0.15);*/
  min-width: 0;
  width: 100%;
}
:host(.clickable) {
  cursor: pointer;
}
:host(.clickable:hover) {
  background: #F0F0F0;
}
:host(.clickable:active) {
  opacity: 0.7;
}

.container {
  height: 100%;
}
.head {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  height: 100%;
  /*
  justify-content: center;
  align-items: flex-start;
  */
  /*gap: var(--Spacings-Spacing-03, 12px);*/
}

.title {
  color: var(--Colors-UI-Primary-Primary-Dark, #003252);
  /* Web & Mobile/Title/Bold 28pt */
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px; /* 135.714% */
  height: 38px;
  /*min-width: 150px;*/
  align-self: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
  /* Web & Mobile/Body/Bold 16pt */
  /* font-family: Inter; */
}

.footer {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  height: 38px;
}

.footer-link {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 6px;
  /* Web & Mobile/Body/Regular 14pt */
  /* font-family: Inter; */
  color: var(--Colors-UI-Secondary-Secondary-Medium, #4E758E);
  /* Web & Mobile/Body/Bold 14pt */
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration: underline;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
}

.footer-icon img {
  width: 16px;
  height: 16px;
}
.footer-value {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: var(--Colors-UI-Status-Success-Success-Medium, #14B814);
  text-overflow: ellipsis;
  /* Web & Mobile/Body/Regular 14pt */
  /* font-family: Inter; */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.hide {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/link-card.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,sDAAsD;EACtD,gDAAgD;EAChD,8CAA8C;EAC9C,+CAA+C;EAC/C,sBAAsB;EACtB,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,sDAAsD;EACtD,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,YAAY;EACZ;;;GAGC;EACD,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,OAAO;EACP,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,wBAAwB;EACxB,2DAA2D;EAC3D,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,8DAA8D;EAC9D,uBAAuB;EACvB,mCAAmC;EACnC,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":[":host {\n  display: flex;\n  padding-top: 22px;\n  background: var(--Colors-UI-Neutral-Grey-100, #F5F5F5);\n  padding-bottom: var(--Spacings-Spacing-04, 24px);\n  padding-left: var(--Spacings-Spacing-04, 16px);\n  padding-right: var(--Spacings-Spacing-04, 16px);\n  flex-direction: column;\n  /*align-items: flex-start;*/\n  gap: var(--Spacings-Spacing-03, 12px);\n  align-self: stretch;\n  border-radius: var(--Radius-radius-l, 16px);\n  /*box-shadow: 0px 2px 8px 0px rgba(0, 93, 152, 0.15);*/\n  min-width: 0;\n  width: 100%;\n}\n:host(.clickable) {\n  cursor: pointer;\n}\n:host(.clickable:hover) {\n  background: #F0F0F0;\n}\n:host(.clickable:active) {\n  opacity: 0.7;\n}\n\n.container {\n  height: 100%;\n}\n.head {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: stretch;\n  height: 100%;\n  /*\n  justify-content: center;\n  align-items: flex-start;\n  */\n  /*gap: var(--Spacings-Spacing-03, 12px);*/\n}\n\n.title {\n  color: var(--Colors-UI-Primary-Primary-Dark, #003252);\n  /* Web & Mobile/Title/Bold 28pt */\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 38px; /* 135.714% */\n  height: 38px;\n  /*min-width: 150px;*/\n  align-self: stretch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  flex: 1;\n  /* Web & Mobile/Body/Bold 16pt */\n  /* font-family: Inter; */\n}\n\n.footer {\n  display: flex;\n  align-items: flex-start;\n  align-self: stretch;\n  height: 38px;\n}\n\n.footer-link {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 6px;\n  /* Web & Mobile/Body/Regular 14pt */\n  /* font-family: Inter; */\n  color: var(--Colors-UI-Secondary-Secondary-Medium, #4E758E);\n  /* Web & Mobile/Body/Bold 14pt */\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  text-decoration: underline;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: auto;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n}\n\n.footer-icon img {\n  width: 16px;\n  height: 16px;\n}\n.footer-value {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  color: var(--Colors-UI-Status-Success-Success-Medium, #14B814);\n  text-overflow: ellipsis;\n  /* Web & Mobile/Body/Regular 14pt */\n  /* font-family: Inter; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.hide {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
